import { del, get, post, put } from "../../../core/api/client";
import { API_ENDPOINTS } from "../../../core/api/endpoints";

export const searchAvailablePhoneNumbers = async (payload = {}) => {
  return post(API_ENDPOINTS.PHONE_NUMBERS.SHOW_AVAILABLE, payload);
};

export const buyPhoneNumber = async (payload = {}) => {
  return post(API_ENDPOINTS.PHONE_NUMBERS.BUY, payload);
};

export const getPurchasedPhoneNumbers = async (
  clientId,
  params = {},
) => {
  const { limit = 50, offset = 0 } = params;
  const endpoint = `${API_ENDPOINTS.PHONE_NUMBERS.LIST_BY_CLIENT(clientId)}?limit=${limit}&offset=${offset}`;
  return get(endpoint);
};

export const releasePhoneNumber = async (phoneNumber) => {
  return del(API_ENDPOINTS.PHONE_NUMBERS.RELEASE_BY_NUMBER(phoneNumber));
};

export const updatePhoneNumberAssociation = async (id, payload = {}) => {
  return put(API_ENDPOINTS.PHONE_NUMBERS.UPDATE_BY_ID(id), payload);
};

export const getPhoneNumberById = async (id) => {
  return get(API_ENDPOINTS.PHONE_NUMBERS.GET_BY_ID(id));
};

export const getGreetingFileById = async (id) => {
  return get(API_ENDPOINTS.PHONE_NUMBERS.GREETING_BY_ID(id));
};

export const getGreetingUploadUrlById = async (id, payload = {}) => {
  return put(API_ENDPOINTS.PHONE_NUMBERS.GREETING_BY_ID(id), payload);
};

export const uploadGreetingFileToPresignedUrl = async (url, file, headers = {}) => {
  return fetch(url, {
    method: "PUT",
    headers,
    body: file,
  });
};
